//@flow
import React, { Component } from 'react'

/**
 * Wraps the html audio element, providing a props-based interface for playing audio.
 * @memberof components
 */
export default class Audio extends Component {
  audioElement: HTMLAudioElement

  componentDidMount() {

    if (this.props.playing && this.audioElement && this.audioElement.paused) {
      this.audioElement.play()
    }
  }
  componentDidUpdate() {
    const { playing, shouldPause } = this.props
    if (!this.audioElement) return
    if (playing) {
      if (this.audioElement.paused) {
        this.audioElement.play()
      }
    } else {
      this.audioElement.pause()
      if (!shouldPause) {
        if (this.audioElement.currentTime > 0) {
          this.audioElement.currentTime = 0
        }
      }
    }
  }

  render(): ?React.Element<*> {
    const {
      // eslint-disable-next-line
      playing,
      ...restProps
    } = this.props
    return (
      <audio preload="auto" ref={c => (this.audioElement = c)} {...restProps} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Audio.js